import * as React from "react";
const SvgArrowDown = props => <svg viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M0.515015 1.001L1.48201 0.0340009L6 4.5H6.00401L10.515 0.026001L11.489 1L6.00401 6.489L0.515015 1.001Z" fill="currentColor" /></svg>;
export default SvgArrowDown;